const path = 'widgets/news/';
export const ADD_NEWS = `${path}ADD_NEWS`;
export const SET_FILTER_LIMIT = `${path}SET_FILTER_LIMIT`;
export const SET_MAX_QUERY_SIZE = `${path}SET_MAX_QUERY_SIZE`;
export const SET_STATUS = `${path}SET_STATUS`
